export function formatPercentOff(percentOff: number) {
  return `${percentOff}% Off`;
}
